import React, { useEffect, useState, useMemo } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { act } from "react-dom/test-utils";
import { getValue } from "@testing-library/user-event/dist/utils";

function SubjectClassEvaluationCriteria() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
    },
  });

  const [termsData, setTermsData] = useState([]);
  const [termDataId, settermDataId] = useState(null);
  const [classesData, setClassesData] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [subjectData, setsubjectData] = useState([]);
  const [selectedSubjectId, setSelectedSubjectsId] = useState([]);
  const [subjectClassEvaluationCriteria, setSubjectClassEvaluationCriteria] =
    useState([]);
  const [itemHeadData, setItemHeadData] = useState(null);
  const [selecteditemHeadId, setselecteditemHeadId] = useState(null);
  const isCommentChecked = watch("isComment");
  useEffect(() => {
    fetchClassesByCenterId();
    fetchEvaluationCriteriaType();
    fetchSubjectItemHeads();
  }, [triggerRerender]);

  const fetchSubjectClassEvaqluationCriteria = async () => {
    if (!termDataId || !selectedClassId) {
      return;
    }

    try {
      const response = await get(
        `StudentEvaluation/GetSubjectClassEvaluationCriteria?termId=${termDataId}&classId=${selectedClassId}&subjectId=${
          getValues("subjectId").value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSubjectClassEvaluationCriteria(
        response.subjectClassEvaluationCriteria
      );
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };

  const fetchClassesByCenterId = async () => {
    try {
      if (savedCenterId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${savedCenterId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchEvaluationCriteriaType = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationCriteriaType?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTermsData(response?.evaluationTypes);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchSubjectItemHeads = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationSubjectItemHead?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setItemHeadData(response.evaluationTypes);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const HandleEdit = async (id) => {
    try {
      if (id) {
        const response = await get(
          `StudentEvaluation/GetSubjectEvaluationCriteriaById?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const evaluationCriteria = response.subjectClassEvaluationCriteria;
        reset({
          id: evaluationCriteria.id,
          isComment: evaluationCriteria.isComment,
          createdBy: evaluationCriteria.createdBy,
          description: evaluationCriteria.description,
          evaluationSubjectItemHeadId: {
            value: evaluationCriteria?.itemHeadId || "",
            label: evaluationCriteria.itemDescription || "",
          },
          subjectId: {
            value: evaluationCriteria?.subjectId || "",
            label: evaluationCriteria.subjectName || "",
          },
          classId: {
            value: evaluationCriteria?.classId || "",
            label: evaluationCriteria.className || "",
          },
          termId: {
            value: evaluationCriteria.evaluationCriteriaTypeId,
            label: evaluationCriteria.evaluationCriteriaType,
          },
          updatedBy: localStorage.getItem("userId"),
          createdBy: evaluationCriteria.createdBy,
        });
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const HandleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmed) return;
    try {
      if (id) {
        const response = await get(
          `StudentEvaluation/DeleteSubjectEvaluationCriteriaById?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.success) {
          toast.success(response.message || "Success!");
          fetchSubjectClassEvaqluationCriteria();
        } else {
          console.error("Error deleting holiday:", response.message);
        }
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSubjectByClassId = async (ClassId) => {
    try {
      if (savedCenterId) {
        const response = await get(
          `Subject/GetAllSubject?centerId=${savedCenterId}&classId=${ClassId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setsubjectData(response.subjects);
      } else {
        setsubjectData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const filteredClassEvaluationCriteria = subjectClassEvaluationCriteria.filter(
    (item) => item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Item Head",
      selector: (row) => row.itemHead,
      sortable: true,
      width: "150px",
    },
    {
      name: "Activity",
      selector: (row) => row.description,
      sortable: true,
      width: "250px",
    },
    {
      name: "Action",
      width: "70px",
      selector: (row) => (
        <div>
          <button
            type="button"
            className="btn p-0"
            onClick={() => HandleEdit(row.id)}
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            type="button"
            className="btn p-0 ms-1"
            onClick={() => HandleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    var formdata = {
      centerClassId: data.classId.value,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      description: data.description,
      id: data.id,
      evaluationSubjectItemHeadId: data.evaluationSubjectItemHeadId.value,
      organizationId: data.organizationId,
      subjectId: data.subjectId.value,
      evaluationCriteriaTypeId: data.termId.value,
      IsComment: isCommentChecked,
      statusId: 1,
      organizationId: organizationId,
    };
    try {
      const response = await post(
        "StudentEvaluation/AddUpdateSubjectClassEvaluationCriteria",
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        fetchSubjectClassEvaqluationCriteria();
        setValue("evaluationSubjectItemHeadId", "");
        setValue("description", "");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">
          Subject Year Group Evaluation Criteria
        </h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">
                    Term<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`termId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={termsData.map((term) => ({
                          value: term.id,
                          label: term.type,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setSelectedClassId(null);
                            settermDataId(selectedOption.value);
                            setsubjectData([]);
                          } else {
                            setSelectedClassId(selectedOption.value);
                            setValue(
                              `termId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            settermDataId(selectedOption.value);
                          }
                          trigger("termId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.termId && (
                    <small className="text-danger">
                      {errors.termId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Year Group<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setSelectedClassId(null);
                            setValue(`classId`, null);
                            setsubjectData([]);
                            setValue(`subjectId`, null);
                          } else {
                            setSelectedClassId(selectedOption.value);
                            setValue(
                              `classId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            fetchSubjectByClassId(selectedOption.value);
                          }
                          trigger("classId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.classId && (
                    <small className="text-danger">
                      {errors.classId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">
                    Subject<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="subjectId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subjectData
                          .filter((subject) => subject.status)
                          .map((subject) => ({
                            value: subject.id,
                            label: subject.name,
                          }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            fetchSubjectClassEvaqluationCriteria();
                            setValue(`subjectId`, null);
                          } else {
                            setValue(`subjectId`, selectedOption || 0);
                            fetchSubjectClassEvaqluationCriteria();
                          }
                          trigger("subjectId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.subjectId && (
                    <small className="text-danger">
                      {errors.subjectId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Item Head<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="evaluationSubjectItemHeadId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={itemHeadData?.map((subject) => ({
                          value: subject.id,
                          label: subject.description,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`evaluationSubjectItemHeadId`, null);
                          } else {
                            setValue(
                              `evaluationSubjectItemHeadId`,
                              selectedOption || 0
                            );
                            setselecteditemHeadId(selectedOption.value);
                          }
                          trigger("evaluationSubjectItemHeadId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.evaluationSubjectItemHeadId && (
                    <small className="text-danger">
                      {errors.evaluationSubjectItemHeadId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Activity Name<span className="text-danger fs-9">*</span>
                  </label>
                  <textarea
                    {...register(`description`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 250,
                        message: "Maximum of 250 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("description")}
                  ></textarea>
                  {errors.description && (
                    <small className="text-danger">
                      {errors.description.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-12">
                  <div className="form-check form-check-inline">
                    <input
                      {...register("isComment")}
                      type="checkbox"
                      id="isComment"
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="isComment">
                      Check If comments instead of grading
                    </label>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              {/* {subjectClassEvaluationCriteria &&
              subjectClassEvaluationCriteria.length > 0 ? ( */}
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control ms-2"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
              <DataTable
                columns={columns}
                data={filteredClassEvaluationCriteria}
                pagination
                dense
                customStyles={customTableStyles}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
              {/* ) : (
                <p>No data available</p> // Fallback message or loading indicator
              )} */}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default SubjectClassEvaluationCriteria;
